<template>
	<div class="backgrounds">
		<h2>Фоновые изображения</h2>
		<btn l='Добавить фон' i='plus' @press="create()" size="medium"/>
		<hr/>
		<i-list :fields="fields" :data="backgrounds" @input="edit"/>
		<modal title="Фон +" name="background-edit" :height="360" :noFooter="false">
			<div class="body">
				<i-form :data="currentBackground" :scheme="formScheme" @input="save" :showSaveButton="false"/>
			</div>
      <div slot="footer">
        <!-- <btn l="Удалить"  t='d' s='m'  i='trash' @press="remove" pull='left'></btn> -->
        <btn l="Сохранить" t='s' s='m'  i='save' @press="saveForm" pull='right'></btn>
        <btn l="Отмена" t='df' s='m'  i='times' @press="cancel" pull='right'></btn>
      </div>
		</modal>
	</div>
</template>

<script>
export default {
  name: 'backgrounds',
  methods:{
    cancel(){this.$store.commit('modalClose','background-edit');},
    saveForm(){_i.bus.$emit('save-form');},
    remove(){
      this.$store.dispatch("backgroundsRemoveCRUD",this.currentBackground._id);
      this.$store.commit('modalClose', "background-edit");
    },
  	edit(tr){
  		this.currentBackground = tr;
  		this.$store.commit('modalOpen', "background-edit");
  	},
  	create(){
  		this.currentBackground = {};
  		this.$store.commit('modalOpen', "background-edit");
  	},
  	save(background){
        this.$store.dispatch('backgroundsSaveCRUD', background);
        this.$store.commit('modalClose', "background-edit");
  		//console.log("backgrounds:",);

  	}
  },
  created(){
    let self = this;
    _i.crudApi.makeStore(this,'backgrounds',"content/backgrounds");
    /*
    this.$store.registerModule('backgrounds', {
      state: {
        list:[]
      },
      mutations:{
          addBackground(state, background){
              state.list = _(state.list) // start sequence
                .keyBy('_id') // create a dictionary of the 1st array
                .merge(_.keyBy([background], '_id')) 
                .values().value()
          },
          removeBackground(state, backgroundCode){
              state.list = state.reduce((ns,tr)=>{
                  if(tr.code !== backgroundCode) ns.push(tr);
                  return ns;
              },[]);
          }
      },
      actions:{
          loadBackgrounds({ commit, state }){
              self.$http.get("content/backgrounds").then((res) => {
                console.log(res.body)
                  state.list = res.body.backgrounds;
              });
          }
      }
    });

    this.$store.dispatch('loadBackgrounds');*/
  },
  computed:{
  	backgrounds(){
  		return this.$store.state.backgrounds.list;
  	}
  },
  data () {
    return {
    	currentBackground:{},
    	formScheme:{
    		"name": {
		        "type": "string",
		        "label": "Название",
		        "required":true
		    },
    		"image": {
		        "type": "image",
		        "label": "Картинка",
		        "required":true
		    },
    		"path": {
		        "type": "string",
		        "label": "Путь",
		        "required":true
		    }
    	},
    	fields:[
        {label:'#',type:'index'},
        {label:'Картинка',name:'image',type:"image"},
        {label:'Название',name:'name'},
    		{label:'Путь',name:'path'}
    	]
    }
  }
}
</script>

<style lang="css" scoped>
.backgrounds{
	padding:6px 12px;
}
</style>